/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import queryString from "query-string"
import { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"

import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setWarningAlerts } from "../../../globalStore/alertStore"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import UntinTarihuService from "../../../service/billing/untintarihu/untinTarihuService"
import {
  TUntinTarihuGetListReq,
  TUntinTarihuGetListRes,
} from "../../../service/billing/untintarihu/TUntinTarihu"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import { 区分分類コード } from "../../../constant/enum/codes"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import TextInput from "../../../components/InputWrapper/TextInput"
import NinusiSearchModal from "../../../components/SearchModal/NinusiSearchModal"

import { nameofT } from "../../../ts/util/typeUtil"
import KubunService from "../../../service/master/kubun/kubunService"

//#region dummy
export const 荷主ダミー = [
  { 荷主名: "アーステック株式会社", 荷主コード: "100001" },
  { 荷主名: "アサヒロジ株式会社", 荷主コード: "100002" },
]

//#endregion

/**
 * 運賃タリフ一覧
 * @returns
 */
const UntinTarihuList = () => {
  const history = useHistory()
  const location = useLocation()

  // ref
  const ref明細フォーマットフラグ = useRef<boolean>(false)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "UntinTarihuList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TUntinTarihuGetListRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView(data, {
      pageSize,

      calculatedFields: {},

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TUntinTarihuGetListReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    let currentSearchCondition: TUntinTarihuGetListReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new UntinTarihuService().getList(currentSearchCondition)
      // formatItemを入れなおすためフラグを切り替え
      ref明細フォーマットフラグ.current = false

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
      setAccordionController(false)
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TUntinTarihuGetListReq = queryString.parse(location.search)
    set荷主コード(query.荷主コード)
    set荷主(query.荷主)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TUntinTarihuGetListReq => {
    return {
      荷主コード,
      荷主,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TUntinTarihuGetListReq
  ) => {
    return {
      荷主コード: wjCore.isNullOrWhiteSpace(searchCondition.荷主コード ?? "")
        ? ""
        : searchCondition.荷主コード,
      荷主: wjCore.isNullOrWhiteSpace(searchCondition.荷主 ?? "")
        ? ""
        : searchCondition.荷主,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
    // AlertClear
    dispatch(clearAlert())
  }

  const clearSearchState = () => {
    set荷主コード("")
    set荷主("")
    setIsSubmitButton(false)
    ref明細フォーマットフラグ.current = false
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    // ループをフラグで制御？
    if (ref明細フォーマットフラグ.current) return

    // AddNew行を除いてデータ行がある場合に登録ボタン制御
    if (f.rows.length > 1) {
      setIsSubmitButton(true)
    } else {
      setIsSubmitButton(false)
    }

    // buttonControl()
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
    // フォーマットのループ制御
    // ref明細フォーマットフラグ.current = true
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    showInfoToast(`submitてすと`)
    setIsConfirmModalShow(false)
  }

  /**
   * セル編集完了時イベント
   */
  const cellEditEnded = (
    s: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    let col = s.columns[e.col]
    if (e.cancel === true) {
      return
    }
    let newValue = s.getCellData(e.row, e.col, false)
    let rowItem: TUntinTarihuGetListRes = e.getRow().dataItem
    switch (col.binding as keyof TUntinTarihuGetListRes) {
      case nameofT<TUntinTarihuGetListRes>("荷主コード"):
        // TODO: APIから取得したデータリスト使う
        if (col.header === "荷主コード") {
          rowItem.荷主名 =
            荷主ダミー.find((f) => f.荷主コード === newValue)?.荷主名 ?? ""
        }
        break
      default:
        break
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // gridのリスト用DataMap
  const [運賃タリフ区分DataMap, set運賃タリフ区分DataMap] =
    useState<wjcGrid.DataMap<T区分マスタ>>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 荷主検索用
  const [選択行, set選択行] = useState<wjcGrid.Row>()
  const [is荷主検索Modal, setIs荷主検索Modal] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主, set荷主] = useState<string>()

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `食事手当マスタ`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  //DataMap設定
  useEffect(() => {
    Promise.all([new KubunService().getList()]).then(([区分マスタRes]) => {
      set運賃タリフ区分DataMap(
        new wjcGrid.DataMap(
          区分マスタRes.data.filter(
            (d) =>
              d.分類コード === 区分分類コード.受注配車_請求支払.運賃タリフ区分
          ),
          "区分コード",
          "名称1"
        )
      )
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">運賃タリフ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-40rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <ul className="list-cmn">
                          <li className="list-cmn">
                            <div className="d-flex">
                              <TextInput
                                style={{ width: "7rem" }}
                                id="荷主コード"
                                name="荷主コード"
                                value={荷主コード}
                                setValue={set荷主コード}
                                maxLength={6}
                                placeholder="荷主コード"
                              />
                              <TextInput
                                style={{ width: "25rem" }}
                                id="荷主"
                                name="荷主"
                                value={荷主}
                                setValue={set荷主}
                                maxLength={100}
                                placeholder="荷主"
                              />
                            </div>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                }
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                isShowGridRowPickupButton={false}
                gridProperties={{
                  newRowAtTop: true,
                  cellEditEnded,
                }}
                headerComponent={
                  <>
                    <div>
                      <Button
                        type="button"
                        variant={isSubmitButton ? "primary" : "secondary"}
                        className="ms-4"
                        disabled={!isSubmitButton}
                        onClick={() => {
                          // TODO:登録,Validation,
                          beforeSubmit()
                        }}>
                        登録
                      </Button>
                    </div>
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  width={120}
                  header="荷主コード">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TUntinTarihuGetListRes>
                    ) => {
                      return (
                        <div className="d-flex justify-content-between">
                          <div className="text-start">
                            {context.item.荷主コード}
                          </div>
                          <div className="text-end">
                            <a
                              href="*"
                              onClick={(e) => {
                                e.preventDefault()
                                set選択行(context.row)
                                setIs荷主検索Modal(true)
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                            </a>
                          </div>
                        </div>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主名"
                  width={160}
                  header="荷主名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="運賃タリフ区分コード"
                  width={170}
                  dataMap={運賃タリフ区分DataMap}
                  header="運賃タリフ区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={260}
                  header="備考"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 荷主検索 */}
      <NinusiSearchModal
        size="lg"
        setIsShow={setIs荷主検索Modal}
        isShow={is荷主検索Modal}
        setNinusi={(荷主請求) => {
          if (選択行 == null || 選択行.dataItem == null) return
          const casted: TUntinTarihuGetListRes = 選択行.dataItem
          casted.荷主コード = 荷主請求.荷主コード
          casted.荷主名 = 荷主請求.荷主名

          flexGrid?.refresh()
        }}></NinusiSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default UntinTarihuList
